export enum statusEnum {
  ACTIVE,
  INACTIVE,
  VERIFYING_ACCOUNT,
}
